/**
 * We are using the 'Ducks' model for setting up redux
 * essentially this means actions/reducers are all in the one file under /ducks
 * @see https://github.com/erikras/ducks-modular-redux
 */

import landing from "./landing";
import temporary from "./temporary";
import progress from "./progress";
import questions from "./questions";
import valueRanking from "./valueRanking";
import installPrompt from "./installPrompt";

export default {
  landing,
  temporary,
  progress,
  questions,
  valueRanking,
  installPrompt,
};
